<template>
  <div class="breadcrumb-nav">
    <hp5-spacing-vertical xs="xxs" xl="xxs" md="xxs" lg="xxs"></hp5-spacing-vertical>
    <hp5-breadcrumb :items="JSON.stringify(currentBreadcrumbs)" />
    <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
  </div>
</template>
  
<script setup>
  const { breadCrumbs, context } = useFCPModel()  
  const { buildUrl } = useUrls(context.value)
  const safelink = computed(() => context.value.safelink)  
  let currentBreadcrumbs = breadCrumbs.value

  const buildFindCareUrl = () => {
    return buildUrl('/fcp/csearch/', {
        safelink: context.value.safelink,
        empId: context.value.empId,
        networkId: context.value.networkId,
        asOfDate: context.value.asOfDate,
        groupNetworkName: context.value.groupNetworkName,
        groupNetworkUrl: context.value.groupNetworkUrl,
        marketingGroup: context.value.marketingGroup,
      }, false
    )
  }

  watch(safelink, () => {  
    //When the user selects a different network within the marketing group using the Network dropdown, 
    //update the Find Care breadcrumb href to use the newly selected network. PD-3174     
    currentBreadcrumbs[2].href = buildFindCareUrl()       
  })
</script>
  
<style lang="scss">
  /* style that is non-scoped to override component library styling of breadcrumbs */
  hp5-breadcrumb .page-header-content-container {
    padding-left: 0;
  }
</style>
